import DataMapperViewStore from "./DataMapperViewStore";
import DataMapperProfilesStore from "./Profiles/DataMapperProfilesStore";
import DataMapperLibraryStore from "./Library/DataMapperLibraryStore";
import DataMapperSourceStore from "./Source/DataMapperSourceStore";
import DataMapperBrowseStore from "./Browse/DataMapperBrowseStore";
import DataMapperExplorerStore from "./Explorer/DataMapperExplorerStore";
import DataMapperRestoreStore from "./Restore/DataMapperRestoreStore";
import DataMapperProfileStateStore from "./DataMapperProfileStateStore";
import DataMapperSchemasStore from "./Schemas/DataMapperSchemasStore";
import DataMapperLookupTablesStore from "./Lookups/DataMapperLookupTablesStore";
import DataMapperMappingStore from "./Mapping/DataMapperMappingStore";
import DataMapperTargetStore from "./Target/DataMapperTargetStore";
import DataMapperImportStore from "./Import/DataMapperImportStore";
import DataMapperBulkExportStore from "./BulkExport/DataMapperBulkExportStore";
import DataMapperWizardStore from "./wizard/DataMapperWizardStore";

/**
 * View stores for the Data Mapper area, registered by `src/appStoresConfig.ts`.
 *
 * The names are the literal prop names components inject (`injectStores`
 * matches `/\w*Store\b/`), and none may collide with a ServiceStore key:
 * `dataMapperProfilesStore`, `dataMapperSchemasStore`,
 * `dataMapperLookupTablesStore` and `dataMapperMappingConfigsStore` belong to
 * the four ServiceStores, so the route ViewStores carry `View` in their names.
 */
const dataMapperStoreList = [
  // The tab's selection (client + profile ids, and the editors' ids) every Data Mapper screen shares.
  { name: "dataMapperViewStore", store: DataMapperViewStore },
  // The profile's saved UI state (last step + the selected ids), saved debounced.
  { name: "dataMapperProfileStateViewStore", store: DataMapperProfileStateStore },
  { name: "dataMapperProfilesViewStore", store: DataMapperProfilesStore },
  { name: "dataMapperLibraryViewStore", store: DataMapperLibraryStore },
  { name: "dataMapperSourceViewStore", store: DataMapperSourceStore },
  { name: "dataMapperBrowseViewStore", store: DataMapperBrowseStore },
  { name: "dataMapperExplorerViewStore", store: DataMapperExplorerStore },
  // Admin only: the route is requiresAdmin and the store calls nothing for anyone else.
  { name: "dataMapperRestoreViewStore", store: DataMapperRestoreStore },
  { name: "dataMapperSchemasViewStore", store: DataMapperSchemasStore },
  // The Lookup Tables editor's form (the tables stay in the dataMapperLookupTablesStore ServiceStore).
  { name: "dataMapperLookupTablesViewStore", store: DataMapperLookupTablesStore },
  // ONE draft shared by the Map and Transform screens.
  { name: "dataMapperMappingViewStore", store: DataMapperMappingStore },
  // This tab's target database (the Import screen reads its tables from here).
  { name: "dataMapperTargetViewStore", store: DataMapperTargetStore },
  { name: "dataMapperImportViewStore", store: DataMapperImportStore },
  // Titan Bulk Export: the plan, the auto-mappings and the run (its zip is download-only).
  { name: "dataMapperBulkExportViewStore", store: DataMapperBulkExportStore },
  // The wizard frame around every step: the stepper, the step's instructions, Back / Next.
  { name: "dataMapperWizardViewStore", store: DataMapperWizardStore },
];

export default dataMapperStoreList;
